import ReactJS from "react";

function Home() {
  return (
    <>
{/*begin::Toolbar*/}
<div id="kt_app_toolbar" className="app-toolbar  py-3 py-lg-6 ">
              {/*begin::Toolbar container*/}
              <div
                id="kt_app_toolbar_container"
                className="app-container  container-xxl d-flex flex-stack "
              >
                {/*begin::Page title*/}
                <div className="page-title d-flex flex-column justify-content-center flex-wrap me-3 ">
                  {/*begin::Title*/}
                  <h1 className="page-heading d-flex text-gray-900 fw-bold fs-3 flex-column justify-content-center my-0">
                    Users List
                  </h1>
                  {/*end::Title*/}
                  {/*begin::Breadcrumb*/}
                  <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
                    {/*begin::Item*/}
                    <li className="breadcrumb-item text-muted">
                      <a
                        href="https://preview.keenthemes.com/metronic8/demo1/index.html"
                        className="text-muted text-hover-primary"
                      >
                        Home{" "}
                      </a>
                    </li>
                    {/*end::Item*/}
                    {/*begin::Item*/}
                    <li className="breadcrumb-item">
                      <span className="bullet bg-gray-500 w-5px h-2px" />
                    </li>
                    {/*end::Item*/}
                    {/*begin::Item*/}
                    <li className="breadcrumb-item text-muted">
                      User Management{" "}
                    </li>
                    {/*end::Item*/}
                    {/*begin::Item*/}
                    <li className="breadcrumb-item">
                      <span className="bullet bg-gray-500 w-5px h-2px" />
                    </li>
                    {/*end::Item*/}
                    {/*begin::Item*/}
                    <li className="breadcrumb-item text-muted">Users </li>
                    {/*end::Item*/}
                  </ul>
                  {/*end::Breadcrumb*/}
                </div>
                {/*end::Page title*/}
                {/*begin::Actions*/}
                <div className="d-flex align-items-center gap-2 gap-lg-3">
                  {/*begin::Filter menu*/}
                  <div className="m-0">
                    {/*begin::Menu toggle*/}
                    <a
                      href="https://preview.keenthemes.com/metronic8/demo1/apps/user-management/users/list.html#"
                      className="btn btn-sm btn-flex btn-secondary fw-bold"
                      data-kt-menu-trigger="click"
                      data-kt-menu-placement="bottom-end"
                    >
                      <i className="ki-duotone ki-filter fs-6 text-muted me-1">
                        <span className="path1" />
                        <span className="path2" />
                      </i>
                      Filter
                    </a>
                    {/*end::Menu toggle*/}
                    {/*begin::Menu 1*/}
                    <div
                      className="menu menu-sub menu-sub-dropdown w-250px w-md-300px"
                      data-kt-menu="true"
                      id="kt_menu_66223c0876095"
                    >
                      {/*begin::Header*/}
                      <div className="px-7 py-5">
                        <div className="fs-5 text-gray-900 fw-bold">
                          Filter Options
                        </div>
                      </div>
                      {/*end::Header*/}
                      {/*begin::Menu separator*/}
                      <div className="separator border-gray-200" />
                      {/*end::Menu separator*/}
                      {/*begin::Form*/}
                      <div className="px-7 py-5">
                        {/*begin::Input group*/}
                        <div className="mb-10">
                          {/*begin::Label*/}
                          <label className="form-label fw-semibold">
                            Status:
                          </label>
                          {/*end::Label*/}
                          {/*begin::Input*/}
                          <div>
                            <select
                              className="form-select form-select-solid select2-hidden-accessible"
                              
                              data-kt-select2="true"
                              data-close-on-select="false"
                              data-placeholder="Select option"
                              data-dropdown-parent="#kt_menu_66223c0876095"
                              data-allow-clear="true"
                              data-select2-id="select2-data-7-fa5a"
                              tabIndex={-1}
                              aria-hidden="true"
                              data-kt-initialized={1}
                            >
                              <option />
                              <option value={1}>Approved</option>
                              <option value={2}>Pending</option>
                              <option value={2}>In Process</option>
                              <option value={2}>Rejected</option>
                            </select>
                            <span
                              className="select2 select2-container select2-container--bootstrap5"
                              dir="ltr"
                              data-select2-id="select2-data-8-zb56"
                              style={{ width: "100%" }}
                            >
                              <span className="selection">
                                <span
                                  className="select2-selection select2-selection--multiple form-select form-select-solid"
                                  role="combobox"
                                  aria-haspopup="true"
                                  aria-expanded="false"
                                  tabIndex={-1}
                                  aria-disabled="false"
                                >
                                  <ul
                                    className="select2-selection__rendered"
                                    id="select2-pgcu-container"
                                  />
                                  <span className="select2-search select2-search--inline">
                                    <textarea
                                      className="select2-search__field"
                                      tabIndex={0}
                                      autoCorrect="off"
                                      autoCapitalize="none"
                                      spellCheck="false"
                                      role="searchbox"
                                      aria-autocomplete="list"
                                      autoComplete="off"
                                      aria-label="Search"
                                      aria-describedby="select2-pgcu-container"
                                      placeholder="Select option"
                                      style={{ width: "100%" }}
                                      defaultValue={""}
                                    />
                                  </span>
                                </span>
                              </span>
                              <span
                                className="dropdown-wrapper"
                                aria-hidden="true"
                              />
                            </span>
                          </div>
                          {/*end::Input*/}
                        </div>
                        {/*end::Input group*/}
                        {/*begin::Input group*/}
                        <div className="mb-10">
                          {/*begin::Label*/}
                          <label className="form-label fw-semibold">
                            Member Type:
                          </label>
                          {/*end::Label*/}
                          {/*begin::Options*/}
                          <div className="d-flex">
                            {/*begin::Options*/}
                            <label className="form-check form-check-sm form-check-custom form-check-solid me-5">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                defaultValue={1}
                              />
                              <span className="form-check-label">Author</span>
                            </label>
                            {/*end::Options*/}
                            {/*begin::Options*/}
                            <label className="form-check form-check-sm form-check-custom form-check-solid">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                defaultValue={2}
                                defaultChecked={true}
                              />
                              <span className="form-check-label">Customer</span>
                            </label>
                            {/*end::Options*/}
                          </div>
                          {/*end::Options*/}
                        </div>
                        {/*end::Input group*/}
                        {/*begin::Input group*/}
                        <div className="mb-10">
                          {/*begin::Label*/}
                          <label className="form-label fw-semibold">
                            Notifications:
                          </label>
                          {/*end::Label*/}
                          {/*begin::Switch*/}
                          <div className="form-check form-switch form-switch-sm form-check-custom form-check-solid">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              defaultValue=""
                              name="notifications"
                              defaultChecked={false}
                            />
                            <label className="form-check-label">Enabled</label>
                          </div>
                          {/*end::Switch*/}
                        </div>
                        {/*end::Input group*/}
                        {/*begin::Actions*/}
                        <div className="d-flex justify-content-end">
                          <button
                            type="reset"
                            className="btn btn-sm btn-light btn-active-light-primary me-2"
                            data-kt-menu-dismiss="true"
                          >
                            Reset
                          </button>
                          <button
                            type="submit"
                            className="btn btn-sm btn-primary"
                            data-kt-menu-dismiss="true"
                          >
                            Apply
                          </button>
                        </div>
                        {/*end::Actions*/}
                      </div>
                      {/*end::Form*/}
                    </div>
                    {/*end::Menu 1*/}
                  </div>
                  {/*end::Filter menu*/}
                  {/*begin::Secondary button*/}
                  {/*end::Secondary button*/}
                  {/*begin::Primary button*/}
                  <a
                    href="https://preview.keenthemes.com/metronic8/demo1/apps/user-management/users/list.html#"
                    className="btn btn-sm fw-bold btn-primary"
                    data-bs-toggle="modal"
                    data-bs-target="#kt_modal_create_app"
                  >
                    Create{" "}
                  </a>
                  {/*end::Primary button*/}
                </div>
                {/*end::Actions*/}
              </div>
              {/*end::Toolbar container*/}
            </div>
            {/*end::Toolbar*/}
            {/*begin::Content*/}
            <div
              id="kt_app_content"
              className="app-content  flex-column-fluid "
              data-select2-id="select2-data-kt_app_content"
            >
              {/*begin::Content container*/}
              <div
                id="kt_app_content_container"
                className="app-container  container-xxl "
                data-select2-id="select2-data-kt_app_content_container"
              >
                {/*begin::Card*/}
                <div className="card" data-select2-id="select2-data-134-i7jk">
                  {/*begin::Card header*/}
                  <div
                    className="card-header border-0 pt-6"
                    data-select2-id="select2-data-133-ja7m"
                  >
                    {/*begin::Card title*/}
                    <div className="card-title">
                      {/*begin::Search*/}
                      <div className="d-flex align-items-center position-relative my-1">
                        <i className="ki-duotone ki-magnifier fs-3 position-absolute ms-5">
                          <span className="path1" />
                          <span className="path2" />
                        </i>{" "}
                        <input
                          type="text"
                          data-kt-user-table-filter="search"
                          className="form-control form-control-solid w-250px ps-13"
                          placeholder="Search user"
                        />
                      </div>
                      {/*end::Search*/}
                    </div>
                    {/*begin::Card title*/}
                    {/*begin::Card toolbar*/}
                    <div
                      className="card-toolbar"
                      data-select2-id="select2-data-132-erbp"
                    >
                      {/*begin::Toolbar*/}
                      <div
                        className="d-flex justify-content-end"
                        data-kt-user-table-toolbar="base"
                        data-select2-id="select2-data-131-i76u"
                      >
                        {/*begin::Filter*/}
                        <button
                          type="button"
                          className="btn btn-light-primary me-3"
                          data-kt-menu-trigger="click"
                          data-kt-menu-placement="bottom-end"
                        >
                          <i className="ki-duotone ki-filter fs-2">
                            <span className="path1" />
                            <span className="path2" />
                          </i>{" "}
                          Filter
                        </button>
                        {/*begin::Menu 1*/}
                        <div
                          className="menu menu-sub menu-sub-dropdown w-300px w-md-325px"
                          data-kt-menu="true"
                          style={{}}
                        >
                          {/*begin::Header*/}
                          <div className="px-7 py-5">
                            <div className="fs-5 text-gray-900 fw-bold">
                              Filter Options
                            </div>
                          </div>
                          {/*end::Header*/}
                          {/*begin::Separator*/}
                          <div className="separator border-gray-200" />
                          {/*end::Separator*/}
                          {/*begin::Content*/}
                          <div
                            className="px-7 py-5"
                            data-kt-user-table-filter="form"
                          >
                            {/*begin::Input group*/}
                            <div
                              className="mb-10"
                              data-select2-id="select2-data-130-uwth"
                            >
                              <label className="form-label fs-6 fw-semibold">
                                Role:
                              </label>
                              <select
                                className="form-select form-select-solid fw-bold select2-hidden-accessible"
                                data-kt-select2="true"
                                data-placeholder="Select option"
                                data-allow-clear="true"
                                data-kt-user-table-filter="role"
                                data-hide-search="true"
                                data-select2-id="select2-data-9-uwwy"
                                tabIndex={-1}
                                aria-hidden="true"
                                data-kt-initialized={1}
                              >
                                <option data-select2-id="select2-data-11-ffen" />
                                <option
                                  value="Administrator"
                                  data-select2-id="select2-data-137-jzd4"
                                >
                                  Administrator
                                </option>
                                <option
                                  value="Analyst"
                                  data-select2-id="select2-data-138-rspi"
                                >
                                  Analyst
                                </option>
                                <option
                                  value="Developer"
                                  data-select2-id="select2-data-139-6kx6"
                                >
                                  Developer
                                </option>
                                <option
                                  value="Support"
                                  data-select2-id="select2-data-140-q8l2"
                                >
                                  Support
                                </option>
                                <option
                                  value="Trial"
                                  data-select2-id="select2-data-141-ael5"
                                >
                                  Trial
                                </option>
                              </select>
                              <span
                                className="select2 select2-container select2-container--bootstrap5 select2-container--below"
                                dir="ltr"
                                data-select2-id="select2-data-10-78rf"
                                style={{ width: "100%" }}
                              >
                                <span className="selection">
                                  <span
                                    className="select2-selection select2-selection--single form-select form-select-solid fw-bold"
                                    role="combobox"
                                    aria-haspopup="true"
                                    aria-expanded="false"
                                    tabIndex={0}
                                    aria-disabled="false"
                                    aria-labelledby="select2-fyg2-container"
                                    aria-controls="select2-fyg2-container"
                                  >
                                    <span
                                      className="select2-selection__rendered"
                                      id="select2-fyg2-container"
                                      role="textbox"
                                      aria-readonly="true"
                                      title="Select option"
                                    >
                                      <span className="select2-selection__placeholder">
                                        Select option
                                      </span>
                                    </span>
                                    <span
                                      className="select2-selection__arrow"
                                      role="presentation"
                                    >
                                      <b role="presentation" />
                                    </span>
                                  </span>
                                </span>
                                <span
                                  className="dropdown-wrapper"
                                  aria-hidden="true"
                                />
                              </span>
                            </div>
                            {/*end::Input group*/}
                            {/*begin::Input group*/}
                            <div className="mb-10">
                              <label className="form-label fs-6 fw-semibold">
                                Two Step Verification:
                              </label>
                              <select
                                className="form-select form-select-solid fw-bold select2-hidden-accessible"
                                data-kt-select2="true"
                                data-placeholder="Select option"
                                data-allow-clear="true"
                                data-kt-user-table-filter="two-step"
                                data-hide-search="true"
                                data-select2-id="select2-data-12-jy2u"
                                tabIndex={-1}
                                aria-hidden="true"
                                data-kt-initialized={1}
                              >
                                <option data-select2-id="select2-data-14-p6lf" />
                                <option value="Enabled">Enabled</option>
                              </select>
                              <span
                                className="select2 select2-container select2-container--bootstrap5"
                                dir="ltr"
                                data-select2-id="select2-data-13-l7wu"
                                style={{ width: "100%" }}
                              >
                                <span className="selection">
                                  <span
                                    className="select2-selection select2-selection--single form-select form-select-solid fw-bold"
                                    role="combobox"
                                    aria-haspopup="true"
                                    aria-expanded="false"
                                    tabIndex={0}
                                    aria-disabled="false"
                                    aria-labelledby="select2-h2yw-container"
                                    aria-controls="select2-h2yw-container"
                                  >
                                    <span
                                      className="select2-selection__rendered"
                                      id="select2-h2yw-container"
                                      role="textbox"
                                      aria-readonly="true"
                                      title="Select option"
                                    >
                                      <span className="select2-selection__placeholder">
                                        Select option
                                      </span>
                                    </span>
                                    <span
                                      className="select2-selection__arrow"
                                      role="presentation"
                                    >
                                      <b role="presentation" />
                                    </span>
                                  </span>
                                </span>
                                <span
                                  className="dropdown-wrapper"
                                  aria-hidden="true"
                                />
                              </span>
                            </div>
                            {/*end::Input group*/}
                            {/*begin::Actions*/}
                            <div className="d-flex justify-content-end">
                              <button
                                type="reset"
                                className="btn btn-light btn-active-light-primary fw-semibold me-2 px-6"
                                data-kt-menu-dismiss="true"
                                data-kt-user-table-filter="reset"
                              >
                                Reset
                              </button>
                              <button
                                type="submit"
                                className="btn btn-primary fw-semibold px-6"
                                data-kt-menu-dismiss="true"
                                data-kt-user-table-filter="filter"
                              >
                                Apply
                              </button>
                            </div>
                            {/*end::Actions*/}
                          </div>
                          {/*end::Content*/}
                        </div>
                        {/*end::Menu 1*/} {/*end::Filter*/}
                        {/*begin::Export*/}
                        <button
                          type="button"
                          className="btn btn-light-primary me-3"
                          data-bs-toggle="modal"
                          data-bs-target="#kt_modal_export_users"
                        >
                          <i className="ki-duotone ki-exit-up fs-2">
                            <span className="path1" />
                            <span className="path2" />
                          </i>{" "}
                          Export
                        </button>
                        {/*end::Export*/}
                        {/*begin::Add user*/}
                        <button
                          type="button"
                          className="btn btn-primary"
                          data-bs-toggle="modal"
                          data-bs-target="#kt_modal_add_user"
                        >
                          <i className="ki-duotone ki-plus fs-2" /> Add User
                        </button>
                        {/*end::Add user*/}
                      </div>
                      {/*end::Toolbar*/}
                      {/*begin::Group actions*/}
                      <div
                        className="d-flex justify-content-end align-items-center d-none"
                        data-kt-user-table-toolbar="selected"
                      >
                        <div className="fw-bold me-5">
                          <span
                            className="me-2"
                            data-kt-user-table-select="selected_count"
                          >
                            1
                          </span>{" "}
                          Selected
                        </div>
                        <button
                          type="button"
                          className="btn btn-danger"
                          data-kt-user-table-select="delete_selected"
                        >
                          Delete Selected
                        </button>
                      </div>
                      {/*end::Group actions*/}
                      {/*begin::Modal - Adjust Balance*/}
                      <div
                        className="modal fade"
                        id="kt_modal_export_users"
                        tabIndex={-1}
                        style={{ display: "none" }}
                        aria-hidden="true"
                      >
                        {/*begin::Modal dialog*/}
                        <div
                          className="modal-dialog modal-dialog-centered mw-650px"
                          data-select2-id="select2-data-144-qi0l"
                        >
                          {/*begin::Modal content*/}
                          <div
                            className="modal-content"
                            data-select2-id="select2-data-143-lmih"
                          >
                            {/*begin::Modal header*/}
                            <div className="modal-header">
                              {/*begin::Modal title*/}
                              <h2 className="fw-bold">Export Users</h2>
                              {/*end::Modal title*/}
                              {/*begin::Close*/}
                              <div
                                className="btn btn-icon btn-sm btn-active-icon-primary"
                                data-kt-users-modal-action="close"
                              >
                                <i className="ki-duotone ki-cross fs-1">
                                  <span className="path1" />
                                  <span className="path2" />
                                </i>
                              </div>
                              {/*end::Close*/}
                            </div>
                            {/*end::Modal header*/}
                            {/*begin::Modal body*/}
                            <div className="modal-body scroll-y mx-5 mx-xl-15 my-7">
                              {/*begin::Form*/}
                              <form
                                id="kt_modal_export_users_form"
                                className="form fv-plugins-bootstrap5 fv-plugins-framework"
                                action="https://preview.keenthemes.com/metronic8/demo1/apps/user-management/users/list.html#"
                                data-select2-id="select2-data-kt_modal_export_users_form"
                              >
                                {/*begin::Input group*/}
                                <div className="fv-row mb-10">
                                  {/*begin::Label*/}
                                  <label className="fs-6 fw-semibold form-label mb-2">
                                    Select Roles:
                                  </label>
                                  {/*end::Label*/}
                                  {/*begin::Input*/}
                                  <select
                                    name="role"
                                    data-control="select2"
                                    data-placeholder="Select a role"
                                    data-hide-search="true"
                                    className="form-select form-select-solid fw-bold select2-hidden-accessible"
                                    data-select2-id="select2-data-15-zbso"
                                    tabIndex={-1}
                                    aria-hidden="true"
                                    data-kt-initialized={1}
                                  >
                                    <option data-select2-id="select2-data-17-t7qa"></option>
                                    <option
                                      value="Administrator"
                                      data-select2-id="select2-data-145-kft2"
                                    >
                                      Administrator
                                    </option>
                                    <option
                                      value="Analyst"
                                      data-select2-id="select2-data-146-3tkm"
                                    >
                                      Analyst
                                    </option>
                                    <option
                                      value="Developer"
                                      data-select2-id="select2-data-147-i2sf"
                                    >
                                      Developer
                                    </option>
                                    <option
                                      value="Support"
                                      data-select2-id="select2-data-148-13bp"
                                    >
                                      Support
                                    </option>
                                    <option
                                      value="Trial"
                                      data-select2-id="select2-data-149-9pmz"
                                    >
                                      Trial
                                    </option>
                                  </select>
                                  <span
                                    className="select2 select2-container select2-container--bootstrap5 select2-container--below"
                                    dir="ltr"
                                    data-select2-id="select2-data-16-1ehl"
                                    style={{ width: "100%" }}
                                  >
                                    <span className="selection">
                                      <span
                                        className="select2-selection select2-selection--single form-select form-select-solid fw-bold"
                                        role="combobox"
                                        aria-haspopup="true"
                                        aria-expanded="false"
                                        tabIndex={0}
                                        aria-disabled="false"
                                        aria-labelledby="select2-role-zr-container"
                                        aria-controls="select2-role-zr-container"
                                      >
                                        <span
                                          className="select2-selection__rendered"
                                          id="select2-role-zr-container"
                                          role="textbox"
                                          aria-readonly="true"
                                          title="Analyst"
                                        >
                                          Analyst
                                        </span>
                                        <span
                                          className="select2-selection__arrow"
                                          role="presentation"
                                        >
                                          <b role="presentation" />
                                        </span>
                                      </span>
                                    </span>
                                    <span
                                      className="dropdown-wrapper"
                                      aria-hidden="true"
                                    />
                                  </span>
                                  {/*end::Input*/}
                                </div>
                                {/*end::Input group*/}
                                {/*begin::Input group*/}
                                <div className="fv-row mb-10 fv-plugins-icon-container fv-plugins-bootstrap5-row-valid">
                                  {/*begin::Label*/}
                                  <label className="required fs-6 fw-semibold form-label mb-2">
                                    Select Export Format:
                                  </label>
                                  {/*end::Label*/}
                                  {/*begin::Input*/}
                                  <select
                                    name="format"
                                    data-control="select2"
                                    data-placeholder="Select a format"
                                    data-hide-search="true"
                                    className="form-select form-select-solid fw-bold select2-hidden-accessible"
                                    data-select2-id="select2-data-18-fa8c"
                                    tabIndex={-1}
                                    aria-hidden="true"
                                    data-kt-initialized={1}
                                  >
                                    <option data-select2-id="select2-data-20-bj2m"></option>
                                    <option
                                      value="excel"
                                      data-select2-id="select2-data-151-9it4"
                                    >
                                      Excel
                                    </option>
                                    <option
                                      value="pdf"
                                      data-select2-id="select2-data-152-hca4"
                                    >
                                      PDF
                                    </option>
                                    <option
                                      value="cvs"
                                      data-select2-id="select2-data-153-01x6"
                                    >
                                      CVS
                                    </option>
                                    <option
                                      value="zip"
                                      data-select2-id="select2-data-154-kh1i"
                                    >
                                      ZIP
                                    </option>
                                  </select>
                                  <span
                                    className="select2 select2-container select2-container--bootstrap5 select2-container--below"
                                    dir="ltr"
                                    data-select2-id="select2-data-19-4eux"
                                    style={{ width: "100%" }}
                                  >
                                    <span className="selection">
                                      <span
                                        className="select2-selection select2-selection--single form-select form-select-solid fw-bold"
                                        role="combobox"
                                        aria-haspopup="true"
                                        aria-expanded="false"
                                        tabIndex={0}
                                        aria-disabled="false"
                                        aria-labelledby="select2-format-hh-container"
                                        aria-controls="select2-format-hh-container"
                                      >
                                        <span
                                          className="select2-selection__rendered"
                                          id="select2-format-hh-container"
                                          role="textbox"
                                          aria-readonly="true"
                                          title="CVS"
                                        >
                                          CVS
                                        </span>
                                        <span
                                          className="select2-selection__arrow"
                                          role="presentation"
                                        >
                                          <b role="presentation" />
                                        </span>
                                      </span>
                                    </span>
                                    <span
                                      className="dropdown-wrapper"
                                      aria-hidden="true"
                                    />
                                  </span>
                                  {/*end::Input*/}
                                  <div className="fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback"></div>
                                </div>
                                {/*end::Input group*/}
                                {/*begin::Actions*/}
                                <div className="text-center">
                                  <button
                                    type="reset"
                                    className="btn btn-light me-3"
                                    data-kt-users-modal-action="cancel"
                                  >
                                    Discard
                                  </button>
                                  <button
                                    type="submit"
                                    className="btn btn-primary"
                                    data-kt-users-modal-action="submit"
                                  >
                                    <span className="indicator-label">
                                      Submit
                                    </span>
                                    <span className="indicator-progress">
                                      Please wait...{" "}
                                      <span className="spinner-border spinner-border-sm align-middle ms-2" />
                                    </span>
                                  </button>
                                </div>
                                {/*end::Actions*/}
                              </form>
                              {/*end::Form*/}
                            </div>
                            {/*end::Modal body*/}
                          </div>
                          {/*end::Modal content*/}
                        </div>
                        {/*end::Modal dialog*/}
                      </div>
                      {/*end::Modal - New Card*/}
                      {/*begin::Modal - Add task*/}
                      <div
                        className="modal fade"
                        id="kt_modal_add_user"
                        tabIndex={-1}
                        style={{ display: "none" }}
                        aria-hidden="true"
                      >
                        {/*begin::Modal dialog*/}
                        <div className="modal-dialog modal-dialog-centered mw-650px">
                          {/*begin::Modal content*/}
                          <div className="modal-content">
                            {/*begin::Modal header*/}
                            <div
                              className="modal-header"
                              id="kt_modal_add_user_header"
                            >
                              {/*begin::Modal title*/}
                              <h2 className="fw-bold">Add User</h2>
                              {/*end::Modal title*/}
                              {/*begin::Close*/}
                              <div
                                className="btn btn-icon btn-sm btn-active-icon-primary"
                                data-kt-users-modal-action="close"
                              >
                                <i className="ki-duotone ki-cross fs-1">
                                  <span className="path1" />
                                  <span className="path2" />
                                </i>
                              </div>
                              {/*end::Close*/}
                            </div>
                            {/*end::Modal header*/}
                            {/*begin::Modal body*/}
                            <div className="modal-body px-5 my-7">
                              {/*begin::Form*/}
                              <form
                                id="kt_modal_add_user_form"
                                className="form fv-plugins-bootstrap5 fv-plugins-framework"
                                action="https://preview.keenthemes.com/metronic8/demo1/apps/user-management/users/list.html#"
                              >
                                {/*begin::Scroll*/}
                                <div
                                  className="d-flex flex-column scroll-y px-5 px-lg-10"
                                  id="kt_modal_add_user_scroll"
                                  data-kt-scroll="true"
                                  data-kt-scroll-activate="true"
                                  data-kt-scroll-max-height="auto"
                                  data-kt-scroll-dependencies="#kt_modal_add_user_header"
                                  data-kt-scroll-wrappers="#kt_modal_add_user_scroll"
                                  data-kt-scroll-offset="300px"
                                  style={{ maxHeight: 901 }}
                                >
                                  {/*begin::Input group*/}
                                  <div className="fv-row mb-7">
                                    {/*begin::Label*/}
                                    <label className="d-block fw-semibold fs-6 mb-5">
                                      Avatar
                                    </label>
                                    {/*end::Label*/}
                                    {/*begin::Image placeholder*/}
                                    <style
                                      dangerouslySetInnerHTML={{
                                        __html:
                                          "\n                                                                            .image-input-placeholder {\n                                                                                background-image: url('/metronic8/demo1/assets/media/svg/files/blank-image.svg');\n                                                                            }\n\n                                                                            [data-bs-theme=\"dark\"] .image-input-placeholder {\n                                                                                background-image: url('/metronic8/demo1/assets/media/svg/files/blank-image-dark.svg');\n                                                                            }\n                                                                        "
                                      }}
                                    />
                                    {/*end::Image placeholder*/}
                                    {/*begin::Image input*/}
                                    <div
                                      className="image-input image-input-outline image-input-placeholder"
                                      data-kt-image-input="true"
                                    >
                                      {/*begin::Preview existing avatar*/}
                                      <div
                                        className="image-input-wrapper w-125px h-125px"
                                        style={{
                                          backgroundImage:
                                            "url(/metronic8/demo1/assets/media/avatars/300-6.jpg)"
                                        }}
                                      ></div>
                                      {/*end::Preview existing avatar*/}
                                      {/*begin::Label*/}
                                      <label
                                        className="btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow"
                                        data-kt-image-input-action="change"
                                        data-bs-toggle="tooltip"
                                        aria-label="Change avatar"
                                        data-bs-original-title="Change avatar"
                                        data-kt-initialized={1}
                                      >
                                        <i className="ki-duotone ki-pencil fs-7">
                                          <span className="path1" />
                                          <span className="path2" />
                                        </i>
                                        {/*begin::Inputs*/}
                                        <input
                                          type="file"
                                          name="avatar"
                                          accept=".png, .jpg, .jpeg"
                                        />
                                        <input
                                          type="hidden"
                                          name="avatar_remove"
                                        />
                                        {/*end::Inputs*/}
                                      </label>
                                      {/*end::Label*/}
                                      {/*begin::Cancel*/}
                                      <span
                                        className="btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow"
                                        data-kt-image-input-action="cancel"
                                        data-bs-toggle="tooltip"
                                        aria-label="Cancel avatar"
                                        data-bs-original-title="Cancel avatar"
                                        data-kt-initialized={1}
                                      >
                                        <i className="ki-duotone ki-cross fs-2">
                                          <span className="path1" />
                                          <span className="path2" />
                                        </i>
                                      </span>
                                      {/*end::Cancel*/}
                                      {/*begin::Remove*/}
                                      <span
                                        className="btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow"
                                        data-kt-image-input-action="remove"
                                        data-bs-toggle="tooltip"
                                        aria-label="Remove avatar"
                                        data-bs-original-title="Remove avatar"
                                        data-kt-initialized={1}
                                      >
                                        <i className="ki-duotone ki-cross fs-2">
                                          <span className="path1" />
                                          <span className="path2" />
                                        </i>
                                      </span>
                                      {/*end::Remove*/}
                                    </div>
                                    {/*end::Image input*/}
                                    {/*begin::Hint*/}
                                    <div className="form-text">
                                      Allowed file types: png, jpg, jpeg.
                                    </div>
                                    {/*end::Hint*/}
                                  </div>
                                  {/*end::Input group*/}
                                  {/*begin::Input group*/}
                                  <div className="fv-row mb-7 fv-plugins-icon-container">
                                    {/*begin::Label*/}
                                    <label className="required fw-semibold fs-6 mb-2">
                                      Full Name
                                    </label>
                                    {/*end::Label*/}
                                    {/*begin::Input*/}
                                    <input
                                      type="text"
                                      name="user_name"
                                      className="form-control form-control-solid mb-3 mb-lg-0"
                                      placeholder="Full name"
                                      defaultValue="Emma Smith"
                                    />
                                    {/*end::Input*/}
                                    <div className="fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback"></div>
                                  </div>
                                  {/*end::Input group*/}
                                  {/*begin::Input group*/}
                                  <div className="fv-row mb-7 fv-plugins-icon-container">
                                    {/*begin::Label*/}
                                    <label className="required fw-semibold fs-6 mb-2">
                                      Email
                                    </label>
                                    {/*end::Label*/}
                                    {/*begin::Input*/}
                                    <input
                                      type="email"
                                      name="user_email"
                                      className="form-control form-control-solid mb-3 mb-lg-0"
                                      placeholder="example@domain.com"
                                      defaultValue="smith@kpmg.com"
                                    />
                                    {/*end::Input*/}
                                    <div className="fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback"></div>
                                  </div>
                                  {/*end::Input group*/}
                                  {/*begin::Input group*/}
                                  <div className="mb-5">
                                    {/*begin::Label*/}
                                    <label className="required fw-semibold fs-6 mb-5">
                                      Role
                                    </label>
                                    {/*end::Label*/}
                                    {/*begin::Roles*/}
                                    {/*begin::Input row*/}
                                    <div className="d-flex fv-row">
                                      {/*begin::Radio*/}
                                      <div className="form-check form-check-custom form-check-solid">
                                        {/*begin::Input*/}
                                        <input
                                          className="form-check-input me-3"
                                          name="user_role"
                                          type="radio"
                                          defaultValue={0}
                                          id="kt_modal_update_role_option_0"
                                          defaultChecked={true}
                                        />
                                        {/*end::Input*/}
                                        {/*begin::Label*/}
                                        <label
                                          className="form-check-label"
                                          htmlFor="kt_modal_update_role_option_0"
                                        >
                                          <div className="fw-bold text-gray-800">
                                            Administrator
                                          </div>
                                          <div className="text-gray-600">
                                            Best for business owners and company
                                            administrators
                                          </div>
                                        </label>
                                        {/*end::Label*/}
                                      </div>
                                      {/*end::Radio*/}
                                    </div>
                                    {/*end::Input row*/}
                                    <div className="separator separator-dashed my-5"></div>{" "}
                                    {/*begin::Input row*/}
                                    <div className="d-flex fv-row">
                                      {/*begin::Radio*/}
                                      <div className="form-check form-check-custom form-check-solid">
                                        {/*begin::Input*/}
                                        <input
                                          className="form-check-input me-3"
                                          name="user_role"
                                          type="radio"
                                          defaultValue={1}
                                          id="kt_modal_update_role_option_1"
                                        />
                                        {/*end::Input*/}
                                        {/*begin::Label*/}
                                        <label
                                          className="form-check-label"
                                          htmlFor="kt_modal_update_role_option_1"
                                        >
                                          <div className="fw-bold text-gray-800">
                                            Developer
                                          </div>
                                          <div className="text-gray-600">
                                            Best for developers or people
                                            primarily using the API
                                          </div>
                                        </label>
                                        {/*end::Label*/}
                                      </div>
                                      {/*end::Radio*/}
                                    </div>
                                    {/*end::Input row*/}
                                    <div className="separator separator-dashed my-5"></div>{" "}
                                    {/*begin::Input row*/}
                                    <div className="d-flex fv-row">
                                      {/*begin::Radio*/}
                                      <div className="form-check form-check-custom form-check-solid">
                                        {/*begin::Input*/}
                                        <input
                                          className="form-check-input me-3"
                                          name="user_role"
                                          type="radio"
                                          defaultValue={2}
                                          id="kt_modal_update_role_option_2"
                                        />
                                        {/*end::Input*/}
                                        {/*begin::Label*/}
                                        <label
                                          className="form-check-label"
                                          htmlFor="kt_modal_update_role_option_2"
                                        >
                                          <div className="fw-bold text-gray-800">
                                            Analyst
                                          </div>
                                          <div className="text-gray-600">
                                            Best for people who need full access
                                            to analytics data, but don't need to
                                            update business settings
                                          </div>
                                        </label>
                                        {/*end::Label*/}
                                      </div>
                                      {/*end::Radio*/}
                                    </div>
                                    {/*end::Input row*/}
                                    <div className="separator separator-dashed my-5"></div>{" "}
                                    {/*begin::Input row*/}
                                    <div className="d-flex fv-row">
                                      {/*begin::Radio*/}
                                      <div className="form-check form-check-custom form-check-solid">
                                        {/*begin::Input*/}
                                        <input
                                          className="form-check-input me-3"
                                          name="user_role"
                                          type="radio"
                                          defaultValue={3}
                                          id="kt_modal_update_role_option_3"
                                        />
                                        {/*end::Input*/}
                                        {/*begin::Label*/}
                                        <label
                                          className="form-check-label"
                                          htmlFor="kt_modal_update_role_option_3"
                                        >
                                          <div className="fw-bold text-gray-800">
                                            Support
                                          </div>
                                          <div className="text-gray-600">
                                            Best for employees who regularly
                                            refund payments and respond to
                                            disputes
                                          </div>
                                        </label>
                                        {/*end::Label*/}
                                      </div>
                                      {/*end::Radio*/}
                                    </div>
                                    {/*end::Input row*/}
                                    <div className="separator separator-dashed my-5"></div>{" "}
                                    {/*begin::Input row*/}
                                    <div className="d-flex fv-row">
                                      {/*begin::Radio*/}
                                      <div className="form-check form-check-custom form-check-solid">
                                        {/*begin::Input*/}
                                        <input
                                          className="form-check-input me-3"
                                          name="user_role"
                                          type="radio"
                                          defaultValue={4}
                                          id="kt_modal_update_role_option_4"
                                        />
                                        {/*end::Input*/}
                                        {/*begin::Label*/}
                                        <label
                                          className="form-check-label"
                                          htmlFor="kt_modal_update_role_option_4"
                                        >
                                          <div className="fw-bold text-gray-800">
                                            Trial
                                          </div>
                                          <div className="text-gray-600">
                                            Best for people who need to preview
                                            content data, but don't need to make
                                            any updates
                                          </div>
                                        </label>
                                        {/*end::Label*/}
                                      </div>
                                      {/*end::Radio*/}
                                    </div>
                                    {/*end::Input row*/}
                                    {/*end::Roles*/}
                                  </div>
                                  {/*end::Input group*/}
                                </div>
                                {/*end::Scroll*/}
                                {/*begin::Actions*/}
                                <div className="text-center pt-10">
                                  <button
                                    type="reset"
                                    className="btn btn-light me-3"
                                    data-kt-users-modal-action="cancel"
                                  >
                                    Discard
                                  </button>
                                  <button
                                    type="submit"
                                    className="btn btn-primary"
                                    data-kt-users-modal-action="submit"
                                  >
                                    <span className="indicator-label">
                                      Submit
                                    </span>
                                    <span className="indicator-progress">
                                      Please wait...{" "}
                                      <span className="spinner-border spinner-border-sm align-middle ms-2" />
                                    </span>
                                  </button>
                                </div>
                                {/*end::Actions*/}
                              </form>
                              {/*end::Form*/}
                            </div>
                            {/*end::Modal body*/}
                          </div>
                          {/*end::Modal content*/}
                        </div>
                        {/*end::Modal dialog*/}
                      </div>
                      {/*end::Modal - Add task*/}
                    </div>
                    {/*end::Card toolbar*/}
                  </div>
                  {/*end::Card header*/}
                  {/*begin::Card body*/}
                  <div className="card-body py-4">
                    {/*begin::Table*/}
                    <div
                      id="kt_table_users_wrapper"
                      className="dt-container dt-bootstrap5 dt-empty-footer"
                    >
                      <div id="" className="table-responsive">
                        <table
                          className="table align-middle table-row-dashed fs-6 gy-5 dataTable"
                          id="kt_table_users"
                          style={{ width: "1199.5px" }}
                        >
                          <colgroup>
                            <col style={{ width: "36.3906px" }} />
                            <col style={{ width: "224.656px" }} />
                            <col style={{ width: 181 }} />
                            <col style={{ width: 181 }} />
                            <col style={{ width: 181 }} />
                            <col style={{ width: "243.141px" }} />
                            <col style={{ width: "152.312px" }} />
                          </colgroup>
                          <thead>
                            <tr
                              className="text-start text-muted fw-bold fs-7 text-uppercase gs-0"
                              role="row"
                            >
                              <th
                                className="w-10px pe-2 dt-orderable-none"
                                data-dt-column={0}
                                rowSpan={1}
                                colSpan={1}
                                aria-label="
          
              
          
      "
                              >
                                <span className="dt-column-title">
                                  <div className="form-check form-check-sm form-check-custom form-check-solid me-3">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      data-kt-check="true"
                                      data-kt-check-target="#kt_table_users .form-check-input"
                                      defaultValue={1}
                                    />
                                  </div>
                                </span>
                                <span className="dt-column-order" />
                              </th>
                              <th
                                className="min-w-125px dt-orderable-asc dt-orderable-desc"
                                data-dt-column={1}
                                rowSpan={1}
                                colSpan={1}
                                aria-label="User: Activate to sort"
                                tabIndex={0}
                              >
                                <span className="dt-column-title" role="button">
                                  User
                                </span>
                                <span className="dt-column-order" />
                              </th>
                              <th
                                className="min-w-125px dt-orderable-asc dt-orderable-desc"
                                data-dt-column={2}
                                rowSpan={1}
                                colSpan={1}
                                aria-label="Role: Activate to sort"
                                tabIndex={0}
                              >
                                <span className="dt-column-title" role="button">
                                  Role
                                </span>
                                <span className="dt-column-order" />
                              </th>
                              <th
                                className="min-w-125px dt-orderable-asc dt-orderable-desc"
                                data-dt-column={3}
                                rowSpan={1}
                                colSpan={1}
                                aria-label="Last login: Activate to sort"
                                tabIndex={0}
                              >
                                <span className="dt-column-title" role="button">
                                  Last login
                                </span>
                                <span className="dt-column-order" />
                              </th>
                              <th
                                className="min-w-125px dt-orderable-asc dt-orderable-desc"
                                data-dt-column={4}
                                rowSpan={1}
                                colSpan={1}
                                aria-label="Two-step : Activate to sort"
                                tabIndex={0}
                              >
                                <span className="dt-column-title" role="button">
                                  Two-step
                                </span>
                                <span className="dt-column-order" />
                              </th>
                              <th
                                className="min-w-125px dt-orderable-asc dt-orderable-desc"
                                data-dt-column={5}
                                rowSpan={1}
                                colSpan={1}
                                aria-label="Joined Date: Activate to sort"
                                tabIndex={0}
                              >
                                <span className="dt-column-title" role="button">
                                  Joined Date
                                </span>
                                <span className="dt-column-order" />
                              </th>
                              <th
                                className="text-end min-w-100px dt-orderable-none"
                                data-dt-column={6}
                                rowSpan={1}
                                colSpan={1}
                                aria-label="Actions"
                              >
                                <span className="dt-column-title">Actions</span>
                                <span className="dt-column-order" />
                              </th>
                            </tr>
                          </thead>
                          <tbody className="text-gray-600 fw-semibold">
                            <tr>
                              <td>
                                <div className="form-check form-check-sm form-check-custom form-check-solid">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    defaultValue={1}
                                  />
                                </div>
                              </td>
                              <td className="d-flex align-items-center">
                                {/*begin:: Avatar */}
                                <div className="symbol symbol-circle symbol-50px overflow-hidden me-3">
                                  <a href="https://preview.keenthemes.com/metronic8/demo1/apps/user-management/users/view.html">
                                    <div className="symbol-label">
                                      <img
                                        src="/assets_files/300-6.jpg"
                                        alt="Emma Smith"
                                        className="w-100"
                                      />
                                    </div>
                                  </a>
                                </div>
                                {/*end::Avatar*/}
                                {/*begin::User details*/}
                                <div className="d-flex flex-column">
                                  <a
                                    href="https://preview.keenthemes.com/metronic8/demo1/apps/user-management/users/view.html"
                                    className="text-gray-800 text-hover-primary mb-1"
                                  >
                                    Emma Smith
                                  </a>
                                  <span>smith@kpmg.com</span>
                                </div>
                                {/*begin::User details*/}
                              </td>
                              <td>Administrator </td>
                              <td data-order="2024-04-18T11:40:24+02:00">
                                <div className="badge badge-light fw-bold">
                                  Yesterday
                                </div>
                              </td>
                              <td></td>
                              <td data-order="2024-08-19T14:40:00+02:00">
                                19 Aug 2024, 2:40 pm{" "}
                              </td>
                              <td className="text-end">
                                <a
                                  href="https://preview.keenthemes.com/metronic8/demo1/apps/user-management/users/list.html#"
                                  className="btn btn-light btn-active-light-primary btn-flex btn-center btn-sm"
                                  data-kt-menu-trigger="click"
                                  data-kt-menu-placement="bottom-end"
                                >
                                  Actions
                                  <i className="ki-duotone ki-down fs-5 ms-1" />{" "}
                                </a>
                                {/*begin::Menu*/}
                                <div
                                  className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-semibold fs-7 w-125px py-4"
                                  data-kt-menu="true"
                                >
                                  {/*begin::Menu item*/}
                                  <div className="menu-item px-3">
                                    <a
                                      href="https://preview.keenthemes.com/metronic8/demo1/apps/user-management/users/view.html"
                                      className="menu-link px-3"
                                    >
                                      Edit
                                    </a>
                                  </div>
                                  {/*end::Menu item*/}
                                  {/*begin::Menu item*/}
                                  <div className="menu-item px-3">
                                    <a
                                      href="https://preview.keenthemes.com/metronic8/demo1/apps/user-management/users/list.html#"
                                      className="menu-link px-3"
                                      data-kt-users-table-filter="delete_row"
                                    >
                                      Delete
                                    </a>
                                  </div>
                                  {/*end::Menu item*/}
                                </div>
                                {/*end::Menu*/}
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <div className="form-check form-check-sm form-check-custom form-check-solid">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    defaultValue={1}
                                  />
                                </div>
                              </td>
                              <td className="d-flex align-items-center">
                                {/*begin:: Avatar */}
                                <div className="symbol symbol-circle symbol-50px overflow-hidden me-3">
                                  <a href="https://preview.keenthemes.com/metronic8/demo1/apps/user-management/users/view.html">
                                    <div className="symbol-label fs-3 bg-light-danger text-danger">
                                      M{" "}
                                    </div>
                                  </a>
                                </div>
                                {/*end::Avatar*/}
                                {/*begin::User details*/}
                                <div className="d-flex flex-column">
                                  <a
                                    href="https://preview.keenthemes.com/metronic8/demo1/apps/user-management/users/view.html"
                                    className="text-gray-800 text-hover-primary mb-1"
                                  >
                                    Melody Macy
                                  </a>
                                  <span>melody@altbox.com</span>
                                </div>
                                {/*begin::User details*/}
                              </td>
                              <td>Analyst </td>
                              <td data-order="2024-04-19T11:20:24+02:00">
                                <div className="badge badge-light fw-bold">
                                  20 mins ago
                                </div>
                              </td>
                              <td>
                                <div className="badge badge-light-success fw-bold">
                                  Enabled
                                </div>
                              </td>
                              <td data-order="2024-07-25T17:20:00+02:00">
                                25 Jul 2024, 5:20 pm{" "}
                              </td>
                              <td className="text-end">
                                <a
                                  href="https://preview.keenthemes.com/metronic8/demo1/apps/user-management/users/list.html#"
                                  className="btn btn-light btn-active-light-primary btn-flex btn-center btn-sm"
                                  data-kt-menu-trigger="click"
                                  data-kt-menu-placement="bottom-end"
                                >
                                  Actions
                                  <i className="ki-duotone ki-down fs-5 ms-1" />{" "}
                                </a>
                                {/*begin::Menu*/}
                                <div
                                  className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-semibold fs-7 w-125px py-4"
                                  data-kt-menu="true"
                                >
                                  {/*begin::Menu item*/}
                                  <div className="menu-item px-3">
                                    <a
                                      href="https://preview.keenthemes.com/metronic8/demo1/apps/user-management/users/view.html"
                                      className="menu-link px-3"
                                    >
                                      Edit
                                    </a>
                                  </div>
                                  {/*end::Menu item*/}
                                  {/*begin::Menu item*/}
                                  <div className="menu-item px-3">
                                    <a
                                      href="https://preview.keenthemes.com/metronic8/demo1/apps/user-management/users/list.html#"
                                      className="menu-link px-3"
                                      data-kt-users-table-filter="delete_row"
                                    >
                                      Delete
                                    </a>
                                  </div>
                                  {/*end::Menu item*/}
                                </div>
                                {/*end::Menu*/}
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <div className="form-check form-check-sm form-check-custom form-check-solid">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    defaultValue={1}
                                  />
                                </div>
                              </td>
                              <td className="d-flex align-items-center">
                                {/*begin:: Avatar */}
                                <div className="symbol symbol-circle symbol-50px overflow-hidden me-3">
                                  <a href="https://preview.keenthemes.com/metronic8/demo1/apps/user-management/users/view.html">
                                    <div className="symbol-label">
                                      <img
                                        src="/assets_files/300-1.jpg"
                                        alt="Max Smith"
                                        className="w-100"
                                      />
                                    </div>
                                  </a>
                                </div>
                                {/*end::Avatar*/}
                                {/*begin::User details*/}
                                <div className="d-flex flex-column">
                                  <a
                                    href="https://preview.keenthemes.com/metronic8/demo1/apps/user-management/users/view.html"
                                    className="text-gray-800 text-hover-primary mb-1"
                                  >
                                    Max Smith
                                  </a>
                                  <span>max@kt.com</span>
                                </div>
                                {/*begin::User details*/}
                              </td>
                              <td>Developer </td>
                              <td data-order="2024-04-16T11:40:24+02:00">
                                <div className="badge badge-light fw-bold">
                                  3 days ago
                                </div>
                              </td>
                              <td></td>
                              <td data-order="2024-07-25T21:23:00+02:00">
                                25 Jul 2024, 9:23 pm{" "}
                              </td>
                              <td className="text-end">
                                <a
                                  href="https://preview.keenthemes.com/metronic8/demo1/apps/user-management/users/list.html#"
                                  className="btn btn-light btn-active-light-primary btn-flex btn-center btn-sm"
                                  data-kt-menu-trigger="click"
                                  data-kt-menu-placement="bottom-end"
                                >
                                  Actions
                                  <i className="ki-duotone ki-down fs-5 ms-1" />{" "}
                                </a>
                                {/*begin::Menu*/}
                                <div
                                  className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-semibold fs-7 w-125px py-4"
                                  data-kt-menu="true"
                                >
                                  {/*begin::Menu item*/}
                                  <div className="menu-item px-3">
                                    <a
                                      href="https://preview.keenthemes.com/metronic8/demo1/apps/user-management/users/view.html"
                                      className="menu-link px-3"
                                    >
                                      Edit
                                    </a>
                                  </div>
                                  {/*end::Menu item*/}
                                  {/*begin::Menu item*/}
                                  <div className="menu-item px-3">
                                    <a
                                      href="https://preview.keenthemes.com/metronic8/demo1/apps/user-management/users/list.html#"
                                      className="menu-link px-3"
                                      data-kt-users-table-filter="delete_row"
                                    >
                                      Delete
                                    </a>
                                  </div>
                                  {/*end::Menu item*/}
                                </div>
                                {/*end::Menu*/}
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <div className="form-check form-check-sm form-check-custom form-check-solid">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    defaultValue={1}
                                  />
                                </div>
                              </td>
                              <td className="d-flex align-items-center">
                                {/*begin:: Avatar */}
                                <div className="symbol symbol-circle symbol-50px overflow-hidden me-3">
                                  <a href="https://preview.keenthemes.com/metronic8/demo1/apps/user-management/users/view.html">
                                    <div className="symbol-label">
                                      <img
                                        src="/assets_files/300-5.jpg"
                                        alt="Sean Bean"
                                        className="w-100"
                                      />
                                    </div>
                                  </a>
                                </div>
                                {/*end::Avatar*/}
                                {/*begin::User details*/}
                                <div className="d-flex flex-column">
                                  <a
                                    href="https://preview.keenthemes.com/metronic8/demo1/apps/user-management/users/view.html"
                                    className="text-gray-800 text-hover-primary mb-1"
                                  >
                                    Sean Bean
                                  </a>
                                  <span>sean@dellito.com</span>
                                </div>
                                {/*begin::User details*/}
                              </td>
                              <td>Support </td>
                              <td data-order="2024-04-19T06:40:24+02:00">
                                <div className="badge badge-light fw-bold">
                                  5 hours ago
                                </div>
                              </td>
                              <td>
                                <div className="badge badge-light-success fw-bold">
                                  Enabled
                                </div>
                              </td>
                              <td data-order="2024-04-15T10:30:00+02:00">
                                15 Apr 2024, 10:30 am{" "}
                              </td>
                              <td className="text-end">
                                <a
                                  href="https://preview.keenthemes.com/metronic8/demo1/apps/user-management/users/list.html#"
                                  className="btn btn-light btn-active-light-primary btn-flex btn-center btn-sm"
                                  data-kt-menu-trigger="click"
                                  data-kt-menu-placement="bottom-end"
                                >
                                  Actions
                                  <i className="ki-duotone ki-down fs-5 ms-1" />{" "}
                                </a>
                                {/*begin::Menu*/}
                                <div
                                  className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-semibold fs-7 w-125px py-4"
                                  data-kt-menu="true"
                                >
                                  {/*begin::Menu item*/}
                                  <div className="menu-item px-3">
                                    <a
                                      href="https://preview.keenthemes.com/metronic8/demo1/apps/user-management/users/view.html"
                                      className="menu-link px-3"
                                    >
                                      Edit
                                    </a>
                                  </div>
                                  {/*end::Menu item*/}
                                  {/*begin::Menu item*/}
                                  <div className="menu-item px-3">
                                    <a
                                      href="https://preview.keenthemes.com/metronic8/demo1/apps/user-management/users/list.html#"
                                      className="menu-link px-3"
                                      data-kt-users-table-filter="delete_row"
                                    >
                                      Delete
                                    </a>
                                  </div>
                                  {/*end::Menu item*/}
                                </div>
                                {/*end::Menu*/}
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <div className="form-check form-check-sm form-check-custom form-check-solid">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    defaultValue={1}
                                  />
                                </div>
                              </td>
                              <td className="d-flex align-items-center">
                                {/*begin:: Avatar */}
                                <div className="symbol symbol-circle symbol-50px overflow-hidden me-3">
                                  <a href="https://preview.keenthemes.com/metronic8/demo1/apps/user-management/users/view.html">
                                    <div className="symbol-label">
                                      <img
                                        src="/assets_files/300-25.jpg"
                                        alt="Brian Cox"
                                        className="w-100"
                                      />
                                    </div>
                                  </a>
                                </div>
                                {/*end::Avatar*/}
                                {/*begin::User details*/}
                                <div className="d-flex flex-column">
                                  <a
                                    href="https://preview.keenthemes.com/metronic8/demo1/apps/user-management/users/view.html"
                                    className="text-gray-800 text-hover-primary mb-1"
                                  >
                                    Brian Cox
                                  </a>
                                  <span>brian@exchange.com</span>
                                </div>
                                {/*begin::User details*/}
                              </td>
                              <td>Developer </td>
                              <td data-order="2024-04-17T11:40:24+02:00">
                                <div className="badge badge-light fw-bold">
                                  2 days ago
                                </div>
                              </td>
                              <td>
                                <div className="badge badge-light-success fw-bold">
                                  Enabled
                                </div>
                              </td>
                              <td data-order="2024-05-05T11:30:00+02:00">
                                05 May 2024, 11:30 am{" "}
                              </td>
                              <td className="text-end">
                                <a
                                  href="https://preview.keenthemes.com/metronic8/demo1/apps/user-management/users/list.html#"
                                  className="btn btn-light btn-active-light-primary btn-flex btn-center btn-sm"
                                  data-kt-menu-trigger="click"
                                  data-kt-menu-placement="bottom-end"
                                >
                                  Actions
                                  <i className="ki-duotone ki-down fs-5 ms-1" />{" "}
                                </a>
                                {/*begin::Menu*/}
                                <div
                                  className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-semibold fs-7 w-125px py-4"
                                  data-kt-menu="true"
                                >
                                  {/*begin::Menu item*/}
                                  <div className="menu-item px-3">
                                    <a
                                      href="https://preview.keenthemes.com/metronic8/demo1/apps/user-management/users/view.html"
                                      className="menu-link px-3"
                                    >
                                      Edit
                                    </a>
                                  </div>
                                  {/*end::Menu item*/}
                                  {/*begin::Menu item*/}
                                  <div className="menu-item px-3">
                                    <a
                                      href="https://preview.keenthemes.com/metronic8/demo1/apps/user-management/users/list.html#"
                                      className="menu-link px-3"
                                      data-kt-users-table-filter="delete_row"
                                    >
                                      Delete
                                    </a>
                                  </div>
                                  {/*end::Menu item*/}
                                </div>
                                {/*end::Menu*/}
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <div className="form-check form-check-sm form-check-custom form-check-solid">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    defaultValue={1}
                                  />
                                </div>
                              </td>
                              <td className="d-flex align-items-center">
                                {/*begin:: Avatar */}
                                <div className="symbol symbol-circle symbol-50px overflow-hidden me-3">
                                  <a href="https://preview.keenthemes.com/metronic8/demo1/apps/user-management/users/view.html">
                                    <div className="symbol-label fs-3 bg-light-warning text-warning">
                                      C{" "}
                                    </div>
                                  </a>
                                </div>
                                {/*end::Avatar*/}
                                {/*begin::User details*/}
                                <div className="d-flex flex-column">
                                  <a
                                    href="https://preview.keenthemes.com/metronic8/demo1/apps/user-management/users/view.html"
                                    className="text-gray-800 text-hover-primary mb-1"
                                  >
                                    Mikaela Collins
                                  </a>
                                  <span>mik@pex.com</span>
                                </div>
                                {/*begin::User details*/}
                              </td>
                              <td>Administrator </td>
                              <td data-order="2024-04-14T11:40:24+02:00">
                                <div className="badge badge-light fw-bold">
                                  5 days ago
                                </div>
                              </td>
                              <td></td>
                              <td data-order="2024-09-22T06:43:00+02:00">
                                22 Sep 2024, 6:43 am{" "}
                              </td>
                              <td className="text-end">
                                <a
                                  href="https://preview.keenthemes.com/metronic8/demo1/apps/user-management/users/list.html#"
                                  className="btn btn-light btn-active-light-primary btn-flex btn-center btn-sm"
                                  data-kt-menu-trigger="click"
                                  data-kt-menu-placement="bottom-end"
                                >
                                  Actions
                                  <i className="ki-duotone ki-down fs-5 ms-1" />{" "}
                                </a>
                                {/*begin::Menu*/}
                                <div
                                  className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-semibold fs-7 w-125px py-4"
                                  data-kt-menu="true"
                                >
                                  {/*begin::Menu item*/}
                                  <div className="menu-item px-3">
                                    <a
                                      href="https://preview.keenthemes.com/metronic8/demo1/apps/user-management/users/view.html"
                                      className="menu-link px-3"
                                    >
                                      Edit
                                    </a>
                                  </div>
                                  {/*end::Menu item*/}
                                  {/*begin::Menu item*/}
                                  <div className="menu-item px-3">
                                    <a
                                      href="https://preview.keenthemes.com/metronic8/demo1/apps/user-management/users/list.html#"
                                      className="menu-link px-3"
                                      data-kt-users-table-filter="delete_row"
                                    >
                                      Delete
                                    </a>
                                  </div>
                                  {/*end::Menu item*/}
                                </div>
                                {/*end::Menu*/}
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <div className="form-check form-check-sm form-check-custom form-check-solid">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    defaultValue={1}
                                  />
                                </div>
                              </td>
                              <td className="d-flex align-items-center">
                                {/*begin:: Avatar */}
                                <div className="symbol symbol-circle symbol-50px overflow-hidden me-3">
                                  <a href="https://preview.keenthemes.com/metronic8/demo1/apps/user-management/users/view.html">
                                    <div className="symbol-label">
                                      <img
                                        src="/assets_files/300-9.jpg"
                                        alt="Francis Mitcham"
                                        className="w-100"
                                      />
                                    </div>
                                  </a>
                                </div>
                                {/*end::Avatar*/}
                                {/*begin::User details*/}
                                <div className="d-flex flex-column">
                                  <a
                                    href="https://preview.keenthemes.com/metronic8/demo1/apps/user-management/users/view.html"
                                    className="text-gray-800 text-hover-primary mb-1"
                                  >
                                    Francis Mitcham
                                  </a>
                                  <span>f.mit@kpmg.com</span>
                                </div>
                                {/*begin::User details*/}
                              </td>
                              <td>Trial </td>
                              <td data-order="2024-03-29T11:40:24+02:00">
                                <div className="badge badge-light fw-bold">
                                  3 weeks ago
                                </div>
                              </td>
                              <td></td>
                              <td data-order="2024-10-25T21:23:00+02:00">
                                25 Oct 2024, 9:23 pm{" "}
                              </td>
                              <td className="text-end">
                                <a
                                  href="https://preview.keenthemes.com/metronic8/demo1/apps/user-management/users/list.html#"
                                  className="btn btn-light btn-active-light-primary btn-flex btn-center btn-sm"
                                  data-kt-menu-trigger="click"
                                  data-kt-menu-placement="bottom-end"
                                >
                                  Actions
                                  <i className="ki-duotone ki-down fs-5 ms-1" />{" "}
                                </a>
                                {/*begin::Menu*/}
                                <div
                                  className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-semibold fs-7 w-125px py-4"
                                  data-kt-menu="true"
                                >
                                  {/*begin::Menu item*/}
                                  <div className="menu-item px-3">
                                    <a
                                      href="https://preview.keenthemes.com/metronic8/demo1/apps/user-management/users/view.html"
                                      className="menu-link px-3"
                                    >
                                      Edit
                                    </a>
                                  </div>
                                  {/*end::Menu item*/}
                                  {/*begin::Menu item*/}
                                  <div className="menu-item px-3">
                                    <a
                                      href="https://preview.keenthemes.com/metronic8/demo1/apps/user-management/users/list.html#"
                                      className="menu-link px-3"
                                      data-kt-users-table-filter="delete_row"
                                    >
                                      Delete
                                    </a>
                                  </div>
                                  {/*end::Menu item*/}
                                </div>
                                {/*end::Menu*/}
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <div className="form-check form-check-sm form-check-custom form-check-solid">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    defaultValue={1}
                                  />
                                </div>
                              </td>
                              <td className="d-flex align-items-center">
                                {/*begin:: Avatar */}
                                <div className="symbol symbol-circle symbol-50px overflow-hidden me-3">
                                  <a href="https://preview.keenthemes.com/metronic8/demo1/apps/user-management/users/view.html">
                                    <div className="symbol-label fs-3 bg-light-danger text-danger">
                                      O{" "}
                                    </div>
                                  </a>
                                </div>
                                {/*end::Avatar*/}
                                {/*begin::User details*/}
                                <div className="d-flex flex-column">
                                  <a
                                    href="https://preview.keenthemes.com/metronic8/demo1/apps/user-management/users/view.html"
                                    className="text-gray-800 text-hover-primary mb-1"
                                  >
                                    Olivia Wild
                                  </a>
                                  <span>olivia@corpmail.com</span>
                                </div>
                                {/*begin::User details*/}
                              </td>
                              <td>Administrator </td>
                              <td data-order="2024-04-18T11:40:24+02:00">
                                <div className="badge badge-light fw-bold">
                                  Yesterday
                                </div>
                              </td>
                              <td></td>
                              <td data-order="2024-09-22T22:10:00+02:00">
                                22 Sep 2024, 10:10 pm{" "}
                              </td>
                              <td className="text-end">
                                <a
                                  href="https://preview.keenthemes.com/metronic8/demo1/apps/user-management/users/list.html#"
                                  className="btn btn-light btn-active-light-primary btn-flex btn-center btn-sm"
                                  data-kt-menu-trigger="click"
                                  data-kt-menu-placement="bottom-end"
                                >
                                  Actions
                                  <i className="ki-duotone ki-down fs-5 ms-1" />{" "}
                                </a>
                                {/*begin::Menu*/}
                                <div
                                  className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-semibold fs-7 w-125px py-4"
                                  data-kt-menu="true"
                                >
                                  {/*begin::Menu item*/}
                                  <div className="menu-item px-3">
                                    <a
                                      href="https://preview.keenthemes.com/metronic8/demo1/apps/user-management/users/view.html"
                                      className="menu-link px-3"
                                    >
                                      Edit
                                    </a>
                                  </div>
                                  {/*end::Menu item*/}
                                  {/*begin::Menu item*/}
                                  <div className="menu-item px-3">
                                    <a
                                      href="https://preview.keenthemes.com/metronic8/demo1/apps/user-management/users/list.html#"
                                      className="menu-link px-3"
                                      data-kt-users-table-filter="delete_row"
                                    >
                                      Delete
                                    </a>
                                  </div>
                                  {/*end::Menu item*/}
                                </div>
                                {/*end::Menu*/}
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <div className="form-check form-check-sm form-check-custom form-check-solid">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    defaultValue={1}
                                  />
                                </div>
                              </td>
                              <td className="d-flex align-items-center">
                                {/*begin:: Avatar */}
                                <div className="symbol symbol-circle symbol-50px overflow-hidden me-3">
                                  <a href="https://preview.keenthemes.com/metronic8/demo1/apps/user-management/users/view.html">
                                    <div className="symbol-label fs-3 bg-light-primary text-primary">
                                      N{" "}
                                    </div>
                                  </a>
                                </div>
                                {/*end::Avatar*/}
                                {/*begin::User details*/}
                                <div className="d-flex flex-column">
                                  <a
                                    href="https://preview.keenthemes.com/metronic8/demo1/apps/user-management/users/view.html"
                                    className="text-gray-800 text-hover-primary mb-1"
                                  >
                                    Neil Owen
                                  </a>
                                  <span>owen.neil@gmail.com</span>
                                </div>
                                {/*begin::User details*/}
                              </td>
                              <td>Analyst </td>
                              <td data-order="2024-04-19T11:20:24+02:00">
                                <div className="badge badge-light fw-bold">
                                  20 mins ago
                                </div>
                              </td>
                              <td>
                                <div className="badge badge-light-success fw-bold">
                                  Enabled
                                </div>
                              </td>
                              <td data-order="2024-06-24T18:05:00+02:00">
                                24 Jun 2024, 6:05 pm{" "}
                              </td>
                              <td className="text-end">
                                <a
                                  href="https://preview.keenthemes.com/metronic8/demo1/apps/user-management/users/list.html#"
                                  className="btn btn-light btn-active-light-primary btn-flex btn-center btn-sm"
                                  data-kt-menu-trigger="click"
                                  data-kt-menu-placement="bottom-end"
                                >
                                  Actions
                                  <i className="ki-duotone ki-down fs-5 ms-1" />{" "}
                                </a>
                                {/*begin::Menu*/}
                                <div
                                  className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-semibold fs-7 w-125px py-4"
                                  data-kt-menu="true"
                                >
                                  {/*begin::Menu item*/}
                                  <div className="menu-item px-3">
                                    <a
                                      href="https://preview.keenthemes.com/metronic8/demo1/apps/user-management/users/view.html"
                                      className="menu-link px-3"
                                    >
                                      Edit
                                    </a>
                                  </div>
                                  {/*end::Menu item*/}
                                  {/*begin::Menu item*/}
                                  <div className="menu-item px-3">
                                    <a
                                      href="https://preview.keenthemes.com/metronic8/demo1/apps/user-management/users/list.html#"
                                      className="menu-link px-3"
                                      data-kt-users-table-filter="delete_row"
                                    >
                                      Delete
                                    </a>
                                  </div>
                                  {/*end::Menu item*/}
                                </div>
                                {/*end::Menu*/}
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <div className="form-check form-check-sm form-check-custom form-check-solid">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    defaultValue={1}
                                  />
                                </div>
                              </td>
                              <td className="d-flex align-items-center">
                                {/*begin:: Avatar */}
                                <div className="symbol symbol-circle symbol-50px overflow-hidden me-3">
                                  <a href="https://preview.keenthemes.com/metronic8/demo1/apps/user-management/users/view.html">
                                    <div className="symbol-label">
                                      <img
                                        src="/assets_files/300-23.jpg"
                                        alt="Dan Wilson"
                                        className="w-100"
                                      />
                                    </div>
                                  </a>
                                </div>
                                {/*end::Avatar*/}
                                {/*begin::User details*/}
                                <div className="d-flex flex-column">
                                  <a
                                    href="https://preview.keenthemes.com/metronic8/demo1/apps/user-management/users/view.html"
                                    className="text-gray-800 text-hover-primary mb-1"
                                  >
                                    Dan Wilson
                                  </a>
                                  <span>dam@consilting.com</span>
                                </div>
                                {/*begin::User details*/}
                              </td>
                              <td>Developer </td>
                              <td data-order="2024-04-16T11:40:24+02:00">
                                <div className="badge badge-light fw-bold">
                                  3 days ago
                                </div>
                              </td>
                              <td></td>
                              <td data-order="2024-06-20T17:30:00+02:00">
                                20 Jun 2024, 5:30 pm{" "}
                              </td>
                              <td className="text-end">
                                <a
                                  href="https://preview.keenthemes.com/metronic8/demo1/apps/user-management/users/list.html#"
                                  className="btn btn-light btn-active-light-primary btn-flex btn-center btn-sm"
                                  data-kt-menu-trigger="click"
                                  data-kt-menu-placement="bottom-end"
                                >
                                  Actions
                                  <i className="ki-duotone ki-down fs-5 ms-1" />{" "}
                                </a>
                                {/*begin::Menu*/}
                                <div
                                  className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-semibold fs-7 w-125px py-4"
                                  data-kt-menu="true"
                                >
                                  {/*begin::Menu item*/}
                                  <div className="menu-item px-3">
                                    <a
                                      href="https://preview.keenthemes.com/metronic8/demo1/apps/user-management/users/view.html"
                                      className="menu-link px-3"
                                    >
                                      Edit
                                    </a>
                                  </div>
                                  {/*end::Menu item*/}
                                  {/*begin::Menu item*/}
                                  <div className="menu-item px-3">
                                    <a
                                      href="https://preview.keenthemes.com/metronic8/demo1/apps/user-management/users/list.html#"
                                      className="menu-link px-3"
                                      data-kt-users-table-filter="delete_row"
                                    >
                                      Delete
                                    </a>
                                  </div>
                                  {/*end::Menu item*/}
                                </div>
                                {/*end::Menu*/}
                              </td>
                            </tr>
                          </tbody>
                          <tfoot />
                        </table>
                      </div>
                      <div id="" className="row">
                        <div
                          id=""
                          className="col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start dt-toolbar"
                        ></div>
                        <div
                          id=""
                          className="col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end"
                        >
                          <div className="dt-paging paging_simple_numbers">
                            <ul className="pagination">
                              <li className="dt-paging-button page-item disabled">
                                <a
                                  className="page-link previous"
                                  aria-controls="kt_table_users"
                                  aria-disabled="true"
                                  aria-label="Previous"
                                  data-dt-idx="previous"
                                  tabIndex={-1}
                                >
                                  <i className="previous" />
                                </a>
                              </li>
                              <li className="dt-paging-button page-item active">
                                <a
                                  href="https://preview.keenthemes.com/metronic8/demo1/apps/user-management/users/list.html#"
                                  className="page-link"
                                  aria-controls="kt_table_users"
                                  aria-current="page"
                                  data-dt-idx={0}
                                  tabIndex={0}
                                >
                                  1
                                </a>
                              </li>
                              <li className="dt-paging-button page-item">
                                <a
                                  href="https://preview.keenthemes.com/metronic8/demo1/apps/user-management/users/list.html#"
                                  className="page-link"
                                  aria-controls="kt_table_users"
                                  data-dt-idx={1}
                                  tabIndex={0}
                                >
                                  2
                                </a>
                              </li>
                              <li className="dt-paging-button page-item">
                                <a
                                  href="https://preview.keenthemes.com/metronic8/demo1/apps/user-management/users/list.html#"
                                  className="page-link"
                                  aria-controls="kt_table_users"
                                  data-dt-idx={2}
                                  tabIndex={0}
                                >
                                  3
                                </a>
                              </li>
                              <li className="dt-paging-button page-item">
                                <a
                                  href="https://preview.keenthemes.com/metronic8/demo1/apps/user-management/users/list.html#"
                                  className="page-link next"
                                  aria-controls="kt_table_users"
                                  aria-label="Next"
                                  data-dt-idx="next"
                                  tabIndex={0}
                                >
                                  <i className="next" />
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/*end::Table*/}
                  </div>
                  {/*end::Card body*/}
                </div>
                {/*end::Card*/}
              </div>
              {/*end::Content container*/}
            </div>
            {/*end::Content*/}
    </>
  );
}

export default Home;
